export default __webpack_public_path__ + "static/media/corn.d8f65721.png";